import lodash, { get, sortBy } from "lodash";

const lodashOperations = {
  identity: ({ entity, condition }) =>
    lodash[condition.operation](get(entity, condition.leftOperand.accessor)) ===
    condition.rightOperand.value,
  isEmpty: ({ entity, condition }) =>
    lodash[condition.operation](get(entity, condition.leftOperand.accessor)) ===
    condition.rightOperand.value,
  default: ({ entity, condition }) =>
    lodash[condition.operation](
      condition.rightOperand.value,
      get(entity, condition.leftOperand.accessor),
    ),
};

const conditionsMatch = (conditions = [], entity) =>
  conditions
    .map((condition) => {
      return (
        lodashOperations[condition.operation] || lodashOperations.default
      )({
        entity,
        condition,
      });
    })
    .every((result) => result === true);

const resolveNextStatusId = (status, project) => {
  const matches = (status.possibleStatuses || []).filter((possibleStatus) =>
    conditionsMatch(possibleStatus.conditions, {
      ...project,
      status,
    }),
  );
  const [next] = sortBy(matches, "order");
  return get(next, "nextStatus");
};

export const getPlayedStatuses = ({ processStatuses = [], project } = {}) => {
  if (!processStatuses.length) return [];

  const statusesById = processStatuses.reduce((acc, status) => {
    acc[status.id] = status;
    return acc;
  }, {});

  const start = sortBy(processStatuses, (status) =>
    parseInt(status.order, 10),
  )[0];

  const path = [];
  const seen = new Set();
  let current = start;

  while (current && !seen.has(current.id)) {
    seen.add(current.id);
    path.push(current);
    const nextId = resolveNextStatusId(current, project);
    current = nextId ? statusesById[nextId] : null;
  }

  return path;
};

export const getPlayedStepNumber = ({
  currentStatus,
  processStatuses = [],
  project,
} = {}) => {
  const fallback = parseInt(get(currentStatus, "order"), 10);
  const currentId = get(currentStatus, "id");
  if (!currentId || !processStatuses.length) {
    return Number.isNaN(fallback) ? null : fallback;
  }

  const path = getPlayedStatuses({ processStatuses, project });
  const index = path.findIndex((status) => status.id === currentId);
  if (index === -1) {
    return Number.isNaN(fallback) ? null : fallback;
  }

  return index + 1;
};
